export default {
  bind(element, { value }, vnode) {
    function handler(e) {
      const originalInput = e.target.value.toLowerCase();
      const transformedInput = '+' + originalInput.replace(/[^0-9]/g, '');
      if (originalInput === transformedInput || '+unavailable'.startsWith(originalInput) || '+anonymous'.startsWith(originalInput))  {
        return;
      }
      e.target.value = transformedInput;
      vnode.elm.dispatchEvent(new CustomEvent('input'));
    }

    if (!value) {
      return;
    }

    element.addEventListener('input', handler);
  }
};